import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bullet_one",
  "use": "bullet_one-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"bullet_one\"><path d=\"M5 0C2.24 0 0 2.24 0 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m1.5 7.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1v-3H4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5v3.5h1c.28 0 .5.22.5.5s-.22.5-.5.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol